import { BehaviorSubject } from "rxjs";

export class PopupController {

  private dataSubject = new BehaviorSubject<any>(null);
  data$ = this.dataSubject.asObservable();
  data: any = null;

  target: [number, number] | null = null;
  stickAt: string | null = null;

  toggle(event: MouseEvent, data: any, name: string) {
    if (this.stickAt === name) {
      this.unstick();
    } else {
      this.stick(event, data, name);
    }
  }

  stick(event: MouseEvent, data: any, name: string) {
    this.stickAt = name;
    this.show(event, data);
  }

  unstick() {
    this.stickAt = null;
    this.hide();
  }

  show(originalEvent: MouseEvent, data: any) {
    originalEvent.stopPropagation();
    this.data = data;
    this.dataSubject.next(data);
    this.target = [originalEvent.clientX, originalEvent.clientY];
  }

  update(originalEvent: MouseEvent, data: any) {
    originalEvent.stopPropagation();

    if (this.stickAt) {
      return;
    }

    this.show(originalEvent, data);
  }

  hide() {
    if (this.stickAt) {
      return;
    }

    this.target = null
    this.data = null
    this.dataSubject.next(null);
  }

  handleClose(data?: any) {
    this.stickAt = null;
    this.hide();
  }
}